import blog from './shared/blog'

export default {
  ...blog,

  pageBlogList: {},
}
